<template>
    <ViewEmailSetting :configKey="$route.params.emailTemplate" />
</template>


<script>
import ViewEmailSetting from '@/views/admin/settings/email/ViewEmailSetting.vue';

export default {
    name: 'DynamicEmailTemplateEditor',
    components: { ViewEmailSetting },
};
</script>


<style lang='scss' scoped></style>